export const allFileTypes = '.gif,.jpg,.jpeg,.png,.doc,.docx,.pdf,.csv,.xls,.xlsx,.xlsm'

export const excelFileTypes = '.csv,.xls,.xlsx,.xlsm'
